import React from 'react';
import { Link } from 'react-scroll';
import './Whychooseus.css';
import whyChooseImg from '../../assets/Investors_main_page-aspect-ratio-5-3-2.webp'

const WhyChooseUs = () => {
  return (
    <section className="why-choose-section">
      <div className="why-choose-container">
        <div className="why-choose-content">
          <div className="why-choose-image">
            <img
              src={whyChooseImg}
              alt="Professional team collaborating on technology solutions"
            />
          </div>
          <div className="why-choose-text">
            <h2 className="why-choose-title">Why Choose Belageri Technologies?</h2>
            <p className="why-choose-description">
            Belageri Technologies Pvt. Ltd. is your trusted partner for digital transformation. Backed by extensive software development experience, we craft innovative solutions that fuel business growth. Our expert team leverages deep technical knowledge and industry best practices to deliver software products that exceed expectations.
            </p>
            <div className="why-choose-highlights">
              <div className="highlight-item">
                <span className="highlight-number">3+</span>
                <span className="highlight-text">Years of Experience</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-number">20+</span>
                <span className="highlight-text">Projects Delivered</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-number">24/7</span>
                <span className="highlight-text">Support & Maintenance</span>
              </div>
            </div>
            <Link
              to="contact"
              smooth={true}
              duration={500}
              offset={-70}
              className="why-choose-btn"
            >
              Start Your Project →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;